import axios from "axios";

const API_BASE_URL = "https://liman.finance/user";

const instance = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true, // Çerezlerin otomatik gönderilmesini sağlar
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.error("Unauthorized. Please log in again.");
    }
    return Promise.reject(error);
  }
);

const login = async (email, password) => {
  try {
    const response = await axios.post(
      `${API_BASE_URL}/login`,
      { email, password },
      {
        withCredentials: true, 
      }
    );

    return { success: true, data: response.data.data, message: "Login successful" };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};

const logout = async (title) => {
  try {
    const response = await instance.post("/logout");
    return { success: true, message: "Logout successful" };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};

const signUp = async ({ firstName, lastName, email, phone, password, termsAccepted }) => {
  try {
    const response = await instance.post("/register", {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_number: phone,
      password,
      confirm_password: password,
      terms_accepted: termsAccepted,
    });

    return { success: true, message: "Sign up successful" };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};

const verifyEmail = async (email, verificationCode) => {
  try {
    const response = await instance.post("/verify-email", {
      email,
      verification_code: verificationCode,
    });

    return { success: true, message: "Verification successful" };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};

const sendVerificationCode = async (email) => {
  try {
    const response = await instance.post("/forgot-password", { email });
    return { success: true, message: "Verification code sent successfully" };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};

const resetPassword = async ({ email, verificationCode, newPassword }) => {
  try {
    const response = await instance.post("/reset-password", {
      email,
      token: verificationCode,
      new_password: newPassword,
      confirm_password: newPassword,
    });
    return { success: true, message: "Password reset successfully" };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};

const changePassword = async (currentPassword, newPassword, confirmNewPassword) => {
  try {
    const response = await instance.post(
      "/change-password",
      {
        current_password: currentPassword,
        new_password: newPassword,
        confirm_new_password: confirmNewPassword,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true, // Cookie'deki session bilgisi gönderilir
      }
    );

    return { success: true, message: "Password changed successfully" };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};

const getQuotaInfo = async () => {
  try {
    const response = await instance.get("/quota-info");
    return { success: true, data: response.data.data, message: "Quota information fetched successfully" };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.message || "An error occurred",
    };
  }
};

const AuthService = {
  login,
  logout,
  signUp,
  verifyEmail,
  sendVerificationCode,
  resetPassword,
  changePassword,
  getQuotaInfo, // Yeni metod eklendi
};

export default AuthService;